import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/expertLadderManage',
  redirect: 'expertLadderManage',
  name: 'expertLadderManage',
  component: Layout,
  children: [
    {
      path: 'expertLadderManage',
      component: () => import('@/views/expertLadderManage/index.vue'),
      name: 'expertLadderManage',
      meta: {
        title: '阶段评审',
        icon: 'tissue',
        requireAuth: true,
      }
    },    
    {
      path: 'expertLadderManage2',
      component: () => import('@/views/expertLadderManage/index.vue'),
      name: 'expertLadderManage',
      meta: {
        title: '结题评审',
        icon: 'tissue',
        requireAuth: true,
      }
    }
  ]
}

export default equipRouter
